import { createFileRoute } from '@tanstack/react-router'
import { PrivateRoutes } from '@/components/PrivateRoutes'

export const Route = createFileRoute('/_authenticated')({
  component: PrivateRoutes,
})
